import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=61f8d51c&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61f8d51c')) {
      api.createRecord('61f8d51c', component.options)
    } else {
      api.reload('61f8d51c', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=61f8d51c&", function () {
      api.rerender('61f8d51c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xAWaAkQPS3xL/JS/comp/ImgFallback.vue"
export default component.exports